module.exports = __webpack_public_path__ + "img/model_68.750cbd53.png";